import API from 'core/api'

export default {

	namespaced: true,

	modules: {},

	state: {},

	getters: {},

	mutations: {},

	actions: {

		'suggest/play/usernames': function(context, params) {

			return new Promise(function(resolve, reject) {

				API.request('misc/suggest/play/usernames', params).then(function(json) {

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})

		}

	}

}